import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import update from 'react-addons-update';
import queryString from 'query-string';

import * as styles from '../styles';
import {request} from '../containers/actions';
import Dialog from '../dialog/dialog';

//@Radium
export default class Violation extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object,
        user: PropTypes.object,
    }

    static defaultProps = {
        style: {},
    }

    state = {
        reported: this.props.reported || false,
        count: this.props.count || '',
        violationText: '',
        violationDialog: false,
    }

    componentDidMount() {
        if (!this.props.count && _.includes(this.context.user.type, 'admin'))
            this.fetch.bind(this)();
    }

    componentDidUpdate(prevProps) {
        if (!_.isEqual(prevProps.target, this.props.target))
            if (!this.props.count && _.includes(this.context.user.type, 'admin'))
                this.fetch.bind(this)();
    }

    async fetch() {
        const response = await this.context.store.dispatch(request({
            path: '/violation/?' + queryString.stringify({target: this.props.target.join(':')}),
        }));
        this.setState({
            reported: response.reported,
            violations: response.results,
            count: response.count,
        });
    }

    async fetchMore() {
        const response = await this.context.store.dispatch(request({
            path: '/violation/?' + queryString.stringify({
                target: this.props.target.join(':'),
                offset: this.state.comments.length,
            }),
        }));
        this.setState(update(this.state, {
            reported: response.reported,
            violations: response.results,
            count: response.count,
        }));
    }

    render() {
        return <span>
            <Dialog isOpen={this.state.violationDialog}>
                <span>
                    {window.gettext('Violation Items')}:
                    <br/>
                    {_.map(Array(4), (__, index) =>
                        <label
                            key={`item-${index}`}
                            htmlFor={`item-${index}`}
                            style={{...styles.field, display: 'flex', alignItems: 'center', height: undefined}}>
                            <input
                                type='checkbox'
                                id={`item-${index}`}
                                style={{float: 'right', marginLeft: '.5em'}}
                                checked={this.state.type & 1 << index}
                                onChange={({target: {checked}}) => this.setState({
                                    type: checked ? this.state.type | 1 << index : this.state.type & ~(1 << index),
                                })}
                            />
                            {window.pgettext('violation', `item-${index}`)}
                        </label>
                    )}
                    {window.gettext('Message')}:
                    <br/>
                    <textarea
                        style={{...styles.field, minWidth: '24em', height: '10em'}}
                        value={this.state.violationText}
                        onChange={({target: {value}}) => this.setState({
                            violationText: value.persian(),
                        })}
                    />
                    <div style={styles.dialogButtonContainer}>
                        {this.context.pending > 0
                            ? <i className='fa-spin fa-spinner fa-2x'></i>
                            : <button
                                key='submit'
                                type='submit'
                                style={styles.defaultDialogButton}
                                onClick={async () => {
                                    if (this.state.violationText) {
                                        await this.context.store.dispatch(request({
                                            path: '/violation/',
                                            method: 'POST',
                                            body: {
                                                target: this.props.target,
                                                type: this.state.type,
                                                message: this.state.violationText,
                                            },
                                        }));
                                        this.setState({violationDialog: false});
                                    }
                                    else {
                                        alert(window.gettext('Failed'));
                                    }
                                }}>
                                {window.gettext('Submit Report')}
                            </button>
                        }
                    </div>
                    
                    <div style={styles.dialogButtonContainer}>
                        <button
                            key='register'
                            type='button'
                            style={styles.dialogButton}
                            onClick={() => this.setState({violationDialog: false})}>
                            {window.gettext('Cancel')}
                        </button>
                    </div>
                </span>
                <span>{window.gettext('Report Violation')}</span>
                <span
                    key='button'
                    style={{
                        cursor: 'pointer',
                        color: '#9a9a9a',
                        ':hover': {color: '#5a5a5a'},
                        ...this.props.style,
                    }}
                    onClick={() => this.setState({violationDialog: true})}>
                    {window.gettext('Report Violation')}
                </span>
            </Dialog>
            <span
                key='hover'
                style={{
                    cursor: 'pointer',
                    color: '#9a9a9a',
                    ':hover': {color: '#5a5a5a'},
                    ...this.props.style,
                }}>
                {_.includes(this.context.user.type, 'admin') ? this.state.count.persian() : null}
            </span>
        </span>;
    }
}
